import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sun, Moon, Download } from "lucide-react";
import SideBarNavDash from "../../componets/SideBarNavDash";
import pdfFile from "../anexos/Release Financeiro - 2º Trimestre Youx Group 2026.pdf";
import {
  DARK_THEME_PAINEL_EXECUTIVO as DARK,
  LIGHT_THEME_PAINEL_EXECUTIVO as LIGHT,
} from "../../componets/temas";

const btnStyle = {
  display: "flex",
  alignItems: "center",
  gap: 6,
  background: "rgba(255,255,255,0.12)",
  border: "1px solid rgba(255,255,255,0.2)",
  borderRadius: 8,
  padding: "7px 14px",
  color: "#fff",
  fontSize: 12,
  fontWeight: 600,
  cursor: "pointer",
  fontFamily: "inherit",
  backdropFilter: "blur(4px)",
};

export default function Release2026T2() {
  const [isLight, setIsLight] = useState(false);
  const navigate = useNavigate();
  const C = isLight ? LIGHT : DARK;

  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        overflow: "hidden",
        background: C.bg,
        fontFamily: "'DM Sans', sans-serif",
        color: C.text,
      }}
    >
      <SideBarNavDash isLight={isLight} />

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <header
          style={{
            background: "linear-gradient(90deg, #4c1d95 0%, #9d174d 100%)",
            color: "#fff",
            padding: "14px 24px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
            flexShrink: 0,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ fontSize: 22, fontWeight: 800 }}>YOUX</span>
            <span style={{ fontSize: 18, fontWeight: 300 }}>GROUP</span>
            <span style={{ marginLeft: 12, fontSize: 13, opacity: 0.7 }}>
              / Release 2026 — 1º Trimestre
            </span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <a
              href={pdfFile}
              download="Release Financeiro - Youx Group 2026 1Trimestre.pdf"
              style={{ ...btnStyle, textDecoration: "none" }}
            >
              <Download size={14} /> Baixar PDF
            </a>
            <button onClick={() => setIsLight(!isLight)} style={btnStyle}>
              {isLight ? <Sun size={14} /> : <Moon size={14} />}{" "}
              {isLight ? "Claro" : "Escuro"}
            </button>
            <button onClick={() => navigate("/inicio")} style={btnStyle}>
              Menu Principal
            </button>
          </div>
        </header>

        {/* PDF Viewer */}
        <div style={{ flex: 1, overflow: "hidden" }}>
          <iframe
            src={`${pdfFile}#toolbar=0`}
            title="Release Financeiro Youx Group 2026 1º Trimestre"
            width="100%"
            height="100%"
            style={{ border: "none", display: "block" }}
          />
        </div>
      </div>
    </div>
  );
}
